module.exports = __webpack_public_path__ + "img/77_dinosaurs.ce67850f.jpg";